import { render, staticRenderFns } from "./collectionHouse.vue?vue&type=template&id=ba329918&scoped=true&"
import script from "./collectionHouse.vue?vue&type=script&lang=js&"
export * from "./collectionHouse.vue?vue&type=script&lang=js&"
import style0 from "./collectionHouse.vue?vue&type=style&index=0&id=ba329918&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba329918",
  null
  
)

export default component.exports